import { getClassNames } from '@websolutespa/bom-core';
import { forwardRef, ReactNode, useContext } from 'react';
import styled from 'styled-components';
import { getVariantKey } from '../../variants';
import { UIStyledComponentProps } from '../types';
import { getCssResponsive } from '../utils';
import { AccordionContext } from './accordion.context';
import { accordionVariants, IAccordionVariants } from './accordion.variants';

const AccordionSubtitleStyle = styled.div <AccordionSubtitleProps>`
  ${props => getVariantKey('subtitle', props.variant, props.variants)}
  ${props => getCssResponsive(props)}
`;

export type AccordionSubtitleProps = UIStyledComponentProps<{
  className?: string;
  variant?: keyof typeof accordionVariants | (string & {});
  variants?: IAccordionVariants;
  children?: ReactNode;
}>;

export const AccordionSubtitle = forwardRef<HTMLDivElement, AccordionSubtitleProps>(
  function AccordionSubtitle({
    className,
    variant,
    variants,
    children,
    ...props
  }, ref) {
    const classNames = getClassNames('accordion__subtitle', className);
    const context = useContext(AccordionContext);
    return (
      <AccordionSubtitleStyle
        className={classNames}
        variant={variant || context.variant}
        variants={variants || context.variants}
        ref={ref}
        {...props}
      >{children}</AccordionSubtitleStyle>
    );
  }
);
